const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-10/PNG%20n.1/publish%2010-1/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 10 Level 1 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
